module.exports = __webpack_public_path__ + "static/media/bluebox.917731f1.svg";